module.exports = "https://cdn.hellotech.com/client-assets/wallmount_tilt_9a6af8c33623c981d115b8b5a881abf3.png";